module.exports = __webpack_public_path__ + "img/qianshou.4edba0b0.png";